import React, { useEffect, useState, useRef } from "react";
import { EventTypes } from "utilFunctions/Constants/Constants";
import DayTimeGrid from "Pages/MyScheduleBeta/CommonComponents/DayTimeGrid";
import WeekTimeGrid from "Pages/MyScheduleBeta/CommonComponents/WeekTimeGrid";
import LectureCard from "Pages/MyScheduleBeta/Components/LectureCard";
import { layoutEvents } from "Pages/MyScheduleBeta/utils/layoutHelpers";
import { useScheduleBetaContext } from "Pages/MyScheduleBeta/Context/ScheduleBetaContext";
import { DAY_WEEK_TYPE } from "Pages/MyScheduleBeta/utils/constants";
import { useMyScheduleBeta } from "Pages/MyScheduleBeta/Hooks/useMyScheduleBeta";

const TabsMain: React.FC = () => {
  const scheduleHook = useMyScheduleBeta();
  const { CallMyScheduleApi } = scheduleHook;
  const {
    todaySchedules,
    setActiveTab,
    eventType: ET,
    selectedDate,
    todayDate,
  } = useScheduleBetaContext();

  const [activeKey, setActiveKey] = useState(EventTypes[0]?.key || "1");
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const onChange = (key: string) => {
    CallMyScheduleApi(key);
  };
  useEffect(() => {
    if (todaySchedules && todaySchedules.length > 0) {
      const lectures = todaySchedules.filter(
        (item: any) => item.eventType === "LECTURE"
      );
      console.log(" ONLY LECTURES Payload:", lectures);
    }
  }, [todaySchedules]);

  const handleTabChange = (key: string) => {
    setActiveKey(key);
    setActiveTab(key);
    onChange(key);
  };

  const isWeek = ET === DAY_WEEK_TYPE.WEEK;

  const activeEventType =
    EventTypes.find((et) => et.key === activeKey) || EventTypes[0];

  const filteredEvents = (todaySchedules || []).filter((event: any) => {
    if (activeEventType.value === "ALL") return true;
    return event.eventType === activeEventType.value;
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Sticky Pill Tabs Bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 16px",
          background: "#fff",
          borderBottom: "1px solid #f0f0f0",
          gap: 8,
        }}
      >
        <div
          style={{
            display: "flex",
            gap: 6,
            overflowX: "auto",
            flexWrap: "nowrap",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            flex: 1,
          }}
        >
          {EventTypes.map((eventType) => {
            const isActive = activeKey === eventType.key;
            return (
              <button
                key={eventType.key}
                onClick={() => handleTabChange(eventType.key)}
                style={{
                  flexShrink: 0,
                  padding: "6px 16px",
                  borderRadius: "999px",
                  border: isActive ? "none" : "1.5px solid #d0d0d0",
                  background: isActive ? "rgb(0, 141, 196)" : "transparent",
                  color: isActive ? "#fff" : "#333",
                  fontWeight: 600,
                  fontSize: "12px",
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  cursor: "pointer",
                  transition: "all 0.18s ease",
                  outline: "none",
                  whiteSpace: "nowrap",
                  lineHeight: "1.5",
                }}
              >
                {eventType.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Grid container with vertical scrolling */}
      <div
        ref={scrollContainerRef}
        style={{
          height: "calc(100vh - 300px)",
          overflow: "auto",
          backgroundColor: "white",
        }}
      >
        {isWeek ? (
          <WeekTimeGrid
            startHour={7}
            endHour={23}
            activeEventType={activeEventType.value}
            isWeek={isWeek}
            scrollContainerRef={scrollContainerRef}
          />
        ) : (
          <DayTimeGrid
            startHour={7}
            endHour={23}
            scrollContainerRef={scrollContainerRef}
            selectedDate={selectedDate}
            todayDate={todayDate}
          >
            {layoutEvents(filteredEvents).map((event: any, index: number) => (
              <LectureCard
                key={`${event.batchTimeTableId}-${index}`}
                event={event}
                gridStartHour={7}
                hourHeight={80}
                left={event._layout?.left || 4}
                width={event._layout?.width}
                right={event._layout?.width ? undefined : 4}
                isWeek={isWeek}
                type={"multiple"}
              />
            ))}
          </DayTimeGrid>
        )}
      </div>
    </div>
  );
};

export default TabsMain;
